import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';

export const HorizontalBar = ({ style }: { style?: StyleProp<ViewStyle> }) => {
  const [styles] = useStyles();
  return <View style={[styles.base, style]} />;
};

const useStyles = createStyles((theme) => ({
  base: {
    backgroundColor: theme.colors.background,
    height: 3,
  },
}));
